import {
  IsEnum,
  IsNumber,
  IsObject,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';

import { AllowedOrderByValues, type OrderBy } from '@common-lib';

import { SearchFilterModel } from '../common';

export class SearchVoucherSortbyModel {
  @IsEnum(['ID', 'CREATED_AT'])
  declare field: 'ID' | 'CREATED_AT';

  @IsEnum(AllowedOrderByValues)
  declare order: OrderBy;
}

export class SearchVoucherFilterModel extends SearchFilterModel {
  @IsOptional()
  @IsString({ each: true })
  declare ids: string[] | undefined;

  @IsOptional()
  @IsString({ each: true })
  declare operatorIds: string[] | undefined;

  @IsOptional()
  @IsString({ each: true })
  declare voucherIssueIds: string[] | undefined;
}

export class SearchVoucherModel {
  @IsOptional()
  @IsObject()
  @ValidateNested()
  declare filter: SearchVoucherFilterModel | undefined;

  @IsOptional()
  @IsNumber()
  declare pageSize: number | undefined;

  @IsOptional()
  @IsString()
  declare pageToken: string | undefined;

  @IsOptional()
  @IsObject()
  @ValidateNested()
  declare sortBy: SearchVoucherSortbyModel;
}
